import React from 'react';
import { howWeWorkData } from '@store/TestingData';
import { PaddingContainer } from '@components';
import * as styles from './HowDoesItWork.module.scss';
import classNames from 'classnames';

export const HowDoesItWork: React.FC = () => {
	return (
		<PaddingContainer className={'white-bg'}>
			<div className={styles.howDoesItWorkContainer}>
				<h2 className={styles.title}>How does it work?</h2>
				<div className={classNames(styles.grid, 'row no-gutters')}>
					{howWeWorkData.map((item) => (
						<div className="col-12 col-xl-4 pt-5" key={item.title}>
							<div className={classNames(styles.item)}>
								<img src={item.icon} className={styles.itemIcon} />
								<div className="font-size-22 font-600 mb-2 mt-3">
									{item.title}
								</div>
								<div className={styles.itemContent}>{item.content}</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</PaddingContainer>
	);
};
